

























import { Component, Vue, Ref } from "vue-property-decorator";
import { DefaultCopy } from "@/plugins/copyobj";
import SliderToggler from "_C/main/Step4/SliderToggler.vue";
import PersonContacts from "_C/main/FormParts/PersonForm/PersonContacts.vue";
import { InsuranceCard, Person } from "@/services/index.defs";

@Component({ components: { SliderToggler, PersonContacts } })
export default class extends Vue {
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    fakePerson: Person = DefaultCopy(this.card.insurer);
    @Ref("form") form: { validate: Function };
    applyChanges() {
        let isValid = this.form.validate();
        if (!isValid) {
            this.cancelChanges();
            return;
        }

        this.card.insurer.email = this.fakePerson.email;
        this.card.insurer.phone = this.fakePerson.phone;
    }
    cancelChanges() {
        this.fakePerson = DefaultCopy(this.card.insurer);
    }
    @Ref("st") st: SliderToggler;
    isEdit(): boolean{
        return this.st.isEdit
    }
}
